/**
 * @file: SettlementItemType.ts
 * @author: eric <xuxiang@zhichetech.com>
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

export enum SettlementItemType {
  Construction = 'construction',
  Material = 'material',
  Other = 'other',
}

export const SettlementItemTypeValueSet = new Set([
  SettlementItemType.Construction,
  SettlementItemType.Material,
  SettlementItemType.Other,
]);
